module.exports = {
    title: "内容社区_惠合科技营销服务平台_精准营销、线上引流",
    description: "惠合科技内容社区包含行业资讯、达人分享、好物推荐、零售叭叭四大版块，为品牌方提供市场铺货前的在线营销服务，满足品牌曝光、活动预热到商城引流的一站式营销需求。",
    keywords: "内容社区,达人分享,广告服务,商城引流,品牌曝光,精准营销"
}